'use strict';
var ErrorUtil = require('../error.utils');
var getHttpStatusString = ErrorUtil.getHttpStatusString;

var app = angular.module('tf.services');
app.service('simpleModalService', ['$uibModal', function ($uibModal) {

    var openModalInstance;

    // called from various methods within factory
    function openModal(template, data, options) {
        var modalOpts = {
            animation: true,
            templateUrl: template,
            controller: ['$scope', '$uibModalInstance', 'modal_data', function ($scope, $uibModalInstance, modal_data) {
                $scope.modal_data = modal_data;
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.close = function (success) {
                    $uibModalInstance.close(success);
                };
            }],
            resolve: {
                modal_data: data
            },
            size: 'medium',
            backdrop: 'static'
        };
        // extend options set in each use type function
        if (options) {
            angular.extend(modalOpts, options);
        }

        if (openModalInstance != null) {
            openModalInstance.dismiss('cancel');
        }

        var modalInstance = $uibModal.open(modalOpts);
        openModalInstance = modalInstance;

        modalInstance.result.then(function() {
            openModalInstance = null;
        });

        return modalInstance.result;
    }

    // one type of modal
    this.alert = function (message, title, size, template_name) {
        var template = 'app/js/services/simple-modal-template/' + (template_name || 'alert') + '.html';
        var opts = {
            size: size || 'sm'
        };
        var data = {
            title: title || 'Alert',
            message: message
        };

        return openModal(template, data, opts);
    }
    this.error = function (rejection, message, title, size, template_name) {
        message = message || '';
        if (rejection) {
            message += '<pre>\r\n' + getHttpStatusString(rejection) + '</pre>';
            size = size || 'lg';
        }
        return this.alert(message, title || 'Error', size, template_name);
    }
}]);
